import { TimePicker } from "@tql/ui-components-react/kendo/dateinputs";
import { Input } from "@tql/ui-components-react/kendo/inputs";
import { Error, Label } from "@tql/ui-components-react/kendo/labels";
import { DatePicker } from "@tql/ui-components-react/tql/dateinputs";
import type { Dispatch, SetStateAction } from "react";

import type { FlagFormErrors, FlagFormValues } from "./utils/validation.ts";

type FlagFormProps = {
	readonly values: FlagFormValues;
	readonly setValues: Dispatch<SetStateAction<FlagFormValues>>;
	readonly errors: FlagFormErrors;
	readonly showFollowupError: boolean;
	readonly showDescriptionError: boolean;
	readonly followupDateId: string;
	readonly followupDateErrorId: string;
	readonly followupTimeId: string;
	readonly followupTimeErrorId: string;
	readonly reasonId: string;
	readonly errorId: string;
};

export const FlagForm = ({
	values,
	setValues,
	errors,
	showFollowupError,
	showDescriptionError,
	followupDateId,
	followupDateErrorId,
	followupTimeId,
	followupTimeErrorId,
	reasonId,
	errorId,
}: FlagFormProps) => {
	return (
		<div className={"flag-form"}>
			<div className={"flag-row"}>
				<div className={"flag-field-col"}>
					<Label>
						Shipment follow up date
						<span className={"required"}>&nbsp;*</span>
					</Label>
					<DatePicker
						aria-describedby={
							showFollowupError ? followupDateErrorId : undefined
						}
						id={followupDateId}
						onChange={(event) =>
							setValues((prev) => ({
								...prev,
								followupDate: event.target.value,
							}))
						}
						value={values.followupDate}
					/>
					<div className={"flag-error-slot"}>
						{showFollowupError ? (
							<Error id={followupDateErrorId}>{errors.followupDate}</Error>
						) : null}
					</div>
				</div>
				<div className={"flag-field-col"}>
					<Label>
						Time<span className={"required"}>&nbsp;*</span>
					</Label>
					<TimePicker
						aria-describedby={
							showFollowupError ? followupTimeErrorId : undefined
						}
						id={followupTimeId}
						onChange={(event) =>
							setValues((prev) => ({
								...prev,
								followupTime: event.target.value,
							}))
						}
						value={values.followupTime}
					/>
					<div className={"flag-error-slot"}>
						{showFollowupError ? (
							<Error id={followupTimeErrorId}>{errors.followupTime}</Error>
						) : null}
					</div>
				</div>
			</div>
			<label htmlFor={reasonId}>
				Follow up reason:
				<span className={"required"}>&nbsp;*</span>
			</label>
			<Input
				ariaDescribedBy={showDescriptionError ? errorId : undefined}
				id={reasonId}
				onChange={(event: { value: string }) =>
					setValues((prev) => ({
						...prev,
						description: event.value,
					}))
				}
				valid={!showDescriptionError}
				value={values.description}
			/>
			<div className={"flag-error-slot"}>
				{showDescriptionError ? (
					<Error id={errorId}>{errors.description}</Error>
				) : null}
			</div>
		</div>
	);
};
